import { createAction } from 'redux-actions'
import request from 'lib/request'
import {
  composeUserProfileUrl,
  isModernOAuthServiceSupported
} from 'lib/utils/oauth'

export const CLEAR_OAUTH_SETTINGS = 'CLEAR_OAUTH_SETTINGS'
export const clearOauthSettings = createAction(CLEAR_OAUTH_SETTINGS)

export const REQUEST_OAUTH_USER_DATA = 'REQUEST_OAUTH_USER_DATA'
export const REQUEST_OAUTH_USER_DATA_ERROR = 'REQUEST_OAUTH_USER_DATA_ERROR'
export const RECEIVE_OAUTH_USER_DATA = 'RECEIVE_OAUTH_USER_DATA'
export const CLEAR_OAUTH_USER_DATA = 'CLEAR_OAUTH_USER_DATA'
export const clearOauthUserData = createAction(CLEAR_OAUTH_USER_DATA)

export const fetchOauthUserData = (
  provider,
  workspaceId,
  sourceSlug,
  integrationSlug,
  accessToken,
  refreshToken
) => dispatch => {
  const useModernOAuth = isModernOAuthServiceSupported(provider)

  const callURL = composeUserProfileUrl({
    accessToken,
    destinationSlug: integrationSlug,
    provider,
    refreshToken,
    sourceSlug,
    workspaceId
  })

  const payload = { provider, workspaceId, sourceSlug }
  if (!useModernOAuth && integrationSlug) {
    payload.integrationSlug = integrationSlug
  }

  dispatch(createAction(REQUEST_OAUTH_USER_DATA)())

  return request(callURL)
    .then(async res => {
      if (!res.ok) {
        const error = new Error(
          `Unable to fetch oauth user data for ${provider}`
        )
        error.status = res.status
        throw error
      }

      const body = await res.json()
      let response

      if (useModernOAuth) {
        response = {
          displayName: body.name
        }
      } else {
        response = body
      }

      dispatch(
        createAction(RECEIVE_OAUTH_USER_DATA)({
          ...payload,
          response
        })
      )
      return response
    })
    .catch(err => dispatch(createAction(REQUEST_OAUTH_USER_DATA_ERROR)(err)))
}

// Oauth LocalStorage interaction

export const REMOVE_OAUTH_LOCAL_STORAGE_VALUE =
  'REMOVE_OAUTH_LOCAL_STORAGE_VALUE'
export const REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR =
  'REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR'
export const removeOauthLocalStorageValue = createAction(
  REMOVE_OAUTH_LOCAL_STORAGE_VALUE
)
export const removeOauthLocalStorageValueError = createAction(
  REMOVE_OAUTH_LOCAL_STORAGE_VALUE_ERROR
)

export const removeLocalStorageValue = key => dispatch => {
  return new Promise((resolve, reject) => {
    try {
      window.localStorage.removeItem(key)
      dispatch(removeOauthLocalStorageValue({ key }))
      resolve()
    } catch (error) {
      dispatch(removeOauthLocalStorageValueError({ key, error }))
      reject(error)
    }
  })
}
export const setOauthLocalStorageValue = (key, value) => {
  return new Promise((resolve, reject) => {
    try {
      window.localStorage.setItem(key, value)
      resolve()
    } catch (e) {
      reject(e)
    }
  })
}
export const initAuthFlowFlags = provider =>
  setOauthLocalStorageValue('isInAuthFlow', provider)
export const clearOauthLocalStorage = () => dispatch =>
  dispatch(removeLocalStorageValue('isInAuthFlow'))
